import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingProps {
  message?: string;
}

export const Loading: React.FC<LoadingProps> = ({ message = 'Loading...' }) => (
  <div className="flex flex-col items-center justify-center py-12">
    <Loader2 className="w-8 h-8 text-primary-500 animate-spin" />
    <p className="mt-4 text-gray-400">{message}</p>
  </div>
);

export const PageLoading: React.FC<LoadingProps> = ({ message = 'Loading...' }) => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900">
    <Loader2 className="w-12 h-12 text-primary-500 animate-spin" />
    <p className="mt-4 text-gray-400 text-lg">{message}</p>
  </div>
);

export default Loading;
